import React from 'react';

import { Button } from 'react-bootstrap5';

import { useContext } from '../Context';

export default function Continue() {
  const { dispatch, state, actions } = useContext();

  const onGoNextClick = () => {
    actions.setNextStep({
      dispatch,
      steps: state.steps,
      isPossibleSkip: true,
      currentStep: state.currentStep,
    });
  };

  return (
    <div className="content onboarding-content">
      <div className="row">
        <div className="col-lg order-lg-last">
          <div className="bg-photo bg-members-onboarding-welcome-photo" />
        </div>
        <div className="col-lg order-lg-first">
          <div className="pt-4 p-sm-4 pe-lg-0 h-100 d-flex flex-column">
            <h1>Welcome Back!</h1>
            <p className="mt-3">
              Let&apos;s finish your onboarding.
            </p>
            <ul className="onboarding-steps">
              {state.onboardingStatus.map((item) => (
                <li className={`mb-2 ${item.completed ? 'completed' : ''} `}>
                  {item.title}
                </li>
              )) }
            </ul>
            <div className="mt-auto">
              <Button
                className="d-block d-sm-inline-block mt-4 mt-sm-3"
                onClick={onGoNextClick}
              >
                Let&apos;s Go!
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
